import React from 'react';
import StudentAccommodationsModal from '../student-accommodations/StudentAccommodationsModal';

// The incident remains part of every request, including detail edits and PDFs.
// The server determines viewing/editing rights for that incident and building.
export default function IncidentSpecialStudentsModal({
  show,
  onHide,
  scope,
  user,
  initialTab = 'search',
  readOnly = false,
}) {
  if (!scope?.incidentID || !scope?.iAccountID) return null;

  return (
    <StudentAccommodationsModal
      show={show}
      onHide={onHide}
      scope={scope}
      userOverride={user}
      initialTab={initialTab}
      readOnly={readOnly}
    />
  );
}
